import { axiosInstance } from 'shared/lib/axios';

import {
  TimesheetAccount,
  TimesheetAccountListRequest,
  TimesheetAccountsByDateResponse,
  TimesheetActualHoursUpdateRequest,
} from './types';

export const getTimesheets = (payload: TimesheetAccountListRequest): Promise<TimesheetAccountsByDateResponse> => {
  const { filters, ...params } = payload;
  return axiosInstance.post(`/api/timesheet/search`, { ...filters }, { params });
};

export const openTimesheetPeriodState = (id: string): Promise<void> => {
  return axiosInstance.put(`/api/period/${id}/reopen`);
};

export const closeTimesheetPeriodState = (id: string): Promise<void> => {
  return axiosInstance.put(`/api/period/${id}/close`);
};

export const approveTimesheetStatus = (id: string): Promise<void> => {
  return axiosInstance.put(`/api/timesheet/${id}/approve`);
};

export const disapproveTimesheetStatus = (id: string): Promise<void> => {
  return axiosInstance.put(`/api/timesheet/${id}/disapprove`);
};

export const updateTimesheetActualHours = (payload: TimesheetActualHoursUpdateRequest): Promise<TimesheetAccount> => {
  return axiosInstance.put(`/api/timesheet/actual-values`, payload);
};
